var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-1 clickable-rows",
    attrs: {
      headers: _vm.headers,
      items: _vm.batches,
      "sort-by": ["startedAt"],
      "sort-desc": [true]
    },
    on: { "click:row": _vm.selectBatch },
    scopedSlots: _vm._u([
      {
        key: "item.startedAt",
        fn: function(ref) {
          var item = ref.item
          return [
            _vm._v(" " + _vm._s(_vm.formatDateTime(item.startedAt)) + " ")
          ]
        }
      },
      {
        key: "item.completedAt",
        fn: function(ref) {
          var item = ref.item
          return [
            _vm._v(
              " " +
                _vm._s(
                  item.completedAt ? _vm.formatDateTime(item.completedAt) : "-"
                ) +
                " "
            )
          ]
        }
      },
      {
        key: "item.durationSeconds",
        fn: function(ref) {
          var item = ref.item
          return [
            _vm._v(" " + _vm._s(_vm.formatDuration(item.durationSeconds)) + " ")
          ]
        }
      },
      {
        key: "item.currentStatus",
        fn: function(ref) {
          var item = ref.item
          return [
            _c(
              "v-chip",
              { attrs: { color: _vm.getStatusColor(item), small: "" } },
              [_vm._v(" " + _vm._s(item.currentStatus) + " ")]
            )
          ]
        }
      },
      {
        key: "item.success",
        fn: function(ref) {
          var item = ref.item
          return [
            _c(
              "v-icon",
              { attrs: { color: item.success ? "success" : "error" } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      item.success ? "mdi-check-circle" : "mdi-alert-circle"
                    ) +
                    " "
                )
              ]
            )
          ]
        }
      },
      {
        key: "item.totalEventsCount",
        fn: function(ref) {
          var item = ref.item
          return [
            _vm._v(" " + _vm._s(item.totalEventsCount.toLocaleString()) + " ")
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }